// import React from 'react';
// import { Row } from 'react-bootstrap';
// import ItemContent from './ItemContent';
import { formatBooleanToYesNo } from 'components/helper/helper';

type Props = { data: any };

const EducationalProgramrSum = ({ data }: Props) => {
  return (
    <div className="gm-summary-section">
      {/* Work Information */}
      <div className="gm-summary-subsection">
        <div className="gm-summary-section-title" style={{ fontSize: 16, marginBottom: 8 }}>Work Information</div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item" style={{ gridColumn: '1/-1' }}>
            <div className="gm-summary-field-label">What was the average number of hours worked per week over the most recent 36 months?*</div>
            <div className="gm-summary-field-value">{data?.average_hours_worked_per_week || '-'}</div>
          </div>
          {(data.average_hours_worked_per_week === '1-5 hours' || data.average_hours_worked_per_week === '6-10 hours' || data.average_hours_worked_per_week === '11-15 hours') && (
            <div className="gm-summary-field-item" style={{ gridColumn: '1/-1' }}>
              <div className="gm-summary-field-label">Was more than 25% of your work hours related to your major of choice?*</div>
              <div className="gm-summary-field-value">{formatBooleanToYesNo(data?.is_more_25_percent_work_related_major)}</div>
            </div>
          )}
        </div>
      </div>
      {/* Extracurricular Programs */}
      <div className="gm-summary-subsection">
        <div className="gm-summary-section-title" style={{ fontSize: 16, marginBottom: 8 }}>Extracurricular Programs Hours of Participation and Leadership</div>
        <div className="gm-summary-field-label" style={{ marginBottom: 8 }}>
          Extracurricular Programs and leadership participation includes activities such as arts, Asian American Club, Boy Scouts/Girl Scouts, Boy's Week/Girl's Week, cheerleading, drama/theater, inter-scholastic athletics, marching band, MEChA, Pride Club, science club, student government, yearbook, Young Democrats/Young Republicans and all other extracurricular activities.
        </div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item" style={{ gridColumn: '1/-1' }}>
            <div className="gm-summary-field-label">Select the average number of hours per week you are/were involved in activities during the last 36 months.*</div>
            <div className="gm-summary-field-value">{data?.average_hours_activities_per_week || '-'}</div>
          </div>
          {(data?.average_hours_worked_per_week !== 'Select' && data?.average_hours_worked_per_week !== '0 hours' && data?.average_hours_worked_per_week !== '') && (
            <div className="gm-summary-field-item" style={{ gridColumn: '1/-1' }}>
              <div className="gm-summary-field-label">Did you hold or have you held any leadership positions in those activities, e.g. class president, club president, team captain, yearbook editor, etc.?*</div>
              <div className="gm-summary-field-value">{formatBooleanToYesNo(data?.is_leadership_positions)}</div>
            </div>
          )}
        </div>
      </div>
      {/* EOP Info */}
      <div className="gm-summary-subsection">
        <div className="gm-summary-section-title" style={{ fontSize: 16, marginBottom: 8 }}>EOP & Important Reminder</div>
        <div className="gm-summary-field-label" style={{ marginBottom: 8 }}>
          Applicants may complete and submit their Cal State Apply application and then later return to complete the EOP portion of the application. To ensure that you submit your EOP application on time, please refer to the EOP Admission by Term page for campus specific information.
        </div>
        <div className="gm-summary-field-label" style={{ marginBottom: 8 }}>
          If you are applying to EOP after you have already submitted your main application, you must return to the dashboard and click on the blue 'submit my changes' button in order for your updates to be received by Cal State Apply staff. Only updates to your EOP application will be considered after your initial submission.
        </div>
        <div className="gm-summary-field-label" style={{ marginBottom: 8 }}>
          The primary goal of the CSU Educational Opportunity Program is to improve access of low-income, first-generation, and historically disadvantaged students from California with potential for academic success by making higher education a possibility.
        </div>
        <div className="gm-summary-field-label" style={{ marginBottom: 8 }}>
          Visit the EOP Admissions site to learn more about EOP, eligibility criteria, and to view EOP application deadlines.
        </div>
        <div className="gm-summary-field-label" style={{ marginBottom: 8 }}>
          Select Yes to apply to EOP. Your EOP application is not considered complete until you complete the three EOP sections and provide two recommenders.
        </div>
        <div className="gm-summary-field-label" style={{ marginBottom: 8 }}>
          Visit the Applicant Help Center for more information.
        </div>
        <div className="gm-summary-field-label" style={{ marginBottom: 8 }}>
          If you have yet to submit any applications for fall 2023, you must complete all EOP sections below before submitting your application. You cannot return later to complete these EOP questions. EOP recommendations are due two-weeks after the campus deadline.
        </div>
        <div className="gm-summary-field-label" style={{ marginBottom: 8 }}>
          If you already submitted a campus application and would like to apply to an EOP program that is still accepting EOP applications, contact the campus EOP office directly for instructions on how to apply.
        </div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item" style={{ gridColumn: '1/-1' }}>
            <div className="gm-summary-field-label">Do you wish to apply to the Educational Opportunity Program (EOP)?*</div>
            <div className="gm-summary-field-value">{data?.wish_to_apply_EOP || '-'}</div>
          </div>
        </div>
      </div>
      {/* Family & Background */}
      <div className="gm-summary-subsection">
        <div className="gm-summary-section-title" style={{ fontSize: 16, marginBottom: 8 }}>Family & Background</div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">If you attended a CSU were you enrolled in an EOP program?*</div>
            <div className="gm-summary-field-value">{data?.is_enrolled_EOP || '-'}</div>
          </div>
          {data?.is_enrolled_EOP === 'Yes' && (
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Select the campus:*</div>
              <div className="gm-summary-field-value">{data?.campus_enrolled_EOP || '-'}</div>
            </div>
          )}
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Where do you plan to live while attending college? (Select one):*</div>
            <div className="gm-summary-field-value">{data?.where_plan_to_live || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">How many brothers and sisters are currently attending a K-12 school?*</div>
            <div className="gm-summary-field-value">{data?.number_brothers_and_sisters_k12 || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">How many brothers and sisters are currently attending or attended college?*</div>
            <div className="gm-summary-field-value">{data?.number_brothers_and_sisters_college || '-'}</div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">How many brothers and sisters received a bachelor's degree?*</div>
            <div className="gm-summary-field-value">{data?.number_brothers_and_sisters_received_bachelor_degree || '-'}</div>
          </div>
          <div className="gm-summary-field-item" style={{ gridColumn: '1/-1' }}>
            <div className="gm-summary-field-label">What languages are spoken in your home?*</div>
            <div className="gm-summary-field-value">{data?.languages_spoken_in_home || '-'}</div>
          </div>
        </div>
      </div>
      {/* Public Assistance */}
      <div className="gm-summary-subsection">
        <div className="gm-summary-section-title" style={{ fontSize: 16, marginBottom: 8 }}>Public Assistance</div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item" style={{ flexBasis: '100%' }}>
            <div className="gm-summary-field-label">During the past 10 years, have you or your family received any income from a public assistance program such as CalWorks, CalFresh, welfare, AFDC, TANF, Social Security, disability, etc.?*</div>
            <div className="gm-summary-field-value">{formatBooleanToYesNo(data?.is_received_income_from_public_assistance_program)}</div>
          </div>
          {data?.is_received_income_from_public_assistance_program && (
            <>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">If yes, how many years?*</div>
                <div className="gm-summary-field-value">{data?.number_year_received_income || '-'}</div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Type(s) of aid:*</div>
                <div className="gm-summary-field-value">{data?.type_of_aid || '-'}</div>
              </div>
            </>
          )}
        </div>
      </div>
      {/* Special Programs */}
      <div className="gm-summary-subsection">
        <div className="gm-summary-section-title" style={{ fontSize: 16, marginBottom: 8 }}>Special Programs</div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item" style={{ flexBasis: '100%' }}>
            <div className="gm-summary-field-label">Have you or your family ever participated in any publicly funded programs such as subsidized housing (public or affordable housing programs, Section 8) employment/training programs (i.e., CETA), school lunch programs, etc.?</div>
            <div className="gm-summary-field-value">{formatBooleanToYesNo(data?.is_participated_in_publicly_funded_programs)}</div>
          </div>
          {data?.is_participated_in_publicly_funded_programs && (
            <>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">If yes, list program(s):*</div>
                <div className="gm-summary-field-value">{data?.publicly_funded_programs || '-'}</div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">If yes, explain*</div>
                <div className="gm-summary-field-value">{data?.work_primarily_to_contribute || '-'}</div>
              </div>
            </>
          )}
          <div className="gm-summary-field-item" style={{ flexBasis: '100%' }}>
            <div className="gm-summary-field-label">Do you or any other children in your family work primarily to contribute to household expenses?</div>
            <div className="gm-summary-field-value">{formatBooleanToYesNo(data?.is_work_primarily_to_contribute)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EducationalProgramrSum;
